// removed by extract-text-webpack-plugin
module.exports = {"cont":"SlideShow__cont___2bfuA","item":"SlideShow__item___X1j_m","animate":"SlideShow__animate___AwcOn","fromRight":"SlideShow__fromRight___3idKV","loading":"SlideShow__loading___3Bnit"};


//////////////////
// WEBPACK FOOTER
// ./src/Rist/modules/SlideShow/SlideShow.css
// module id = 754
// module chunks = 0